import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { ACLService } from "../service/acl.service";
import { OnInit } from "@angular/core";
import { AuthService } from "../../authentication/oidc/auth.service";
import { ProjectService } from "../service/project.service";

@Directive({
  selector: "[acl]",
})
export class ACLDirective implements OnInit {
  private value;
  private data: any = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private aclService: ACLService,
    private authService: AuthService,
    private projectService: ProjectService,
  ) {}
  ngOnInit(): void {
    this.projectService.Current$.subscribe((id) => {
      this.aclService.getData(id);
    });  
    this.aclService.currentUserSubject.subscribe((data) => {
      if (!data) this.data = [];
      else {
        this.authService.userContext.superUser = data.profile.superUser;
        this.data = data.GetAllMasterInfo.UserPermission;
      }

      this.updateView();
    });
  }

  @Input()
  set acl(val) {
    this.value = val;
    this.updateView();
  }

  private updateView() {
    this.viewContainer.clear();
    if (!this.value) this.viewContainer.clear();
    else if (this.authService.userContext.superUser)
      this.viewContainer.createEmbeddedView(this.templateRef);
    else {
      if (this.data.length > 0) {
        let status = this.data.some((x) => x == this.value);
        if (status) this.viewContainer.createEmbeddedView(this.templateRef);
        else this.viewContainer.clear();
      } else this.viewContainer.clear();
    }
  }
}
